import axios from 'axios';
import cookies from 'js-cookie';
import { Modal } from 'antd';
import { _CITY_, envConfig } from 'udian-tob-lib';
import auth from './auth-manager';

const ZHUYUNAPI = {
  getUserInfoFromCode: '/userpolicy/open/bam/v1/login',
  getZhuyunConfig: '/userpolicy/open/bam/v1/config',
  userInfo: '/userpolicy/userpolicy/auth/v1/check_token',
  loginout: '/userpolicy/userpolicy/auth/v1/log_out',
};

const ZHUYUNLOGINURL = {
  prod: 'https://iam.szbus.cn/idp/authcenter/ActionAuthChain?entityId=OauthApphub',
  'dev-maas': 'http://umapi.szbus.cn:28080/idp/authcenter/ActionAuthChain?entityId=apphub',
  'qa-maas': 'http://umapi.szbus.cn:28080/idp/authcenter/ActionAuthChain?entityId=apphub',
};

class ZhuyunLogin {
  timer = null;
  _token = cookies.get('token');
  _userinfo = cookies.get('userinfo') && JSON.parse(cookies.get('userinfo'));
  apiBaseURL = this.getApiUrl('dispatch');
  szbusApiUrl = null;
  szbusZhuyunInfo = {};
  fromSysClientId = '';
  fromSysUrl = '';
  // 第一次进页面拉取接口
  isFirst = true;
  _config = {
    domain: process.env.BUILD_TO === 'prod' ? 'com' : 'net',
  };
  commonGetInterfaceData(url, params = {}) {
    return axios.post(url, params).then((res) => {
      return Promise.resolve(res.data.data);
    });
  }
  // curSystemCode =
  getAuthCode(url) {
    let re = /(code=\w*)/g;
    let _code = url.match(re);
    if (_code && _code[0]) {
      _code = _code[0].split('=')[1];
      return _code;
    }
    return false;
  }
  getApiUrl(domain, env = process.env.BUILD_TO) {
    return envConfig.getApiUrl(domain, env);
  }
  // 通过token获取用户信息
  getUserInfo() {
    return axios.post(this.apiBaseURL + ZHUYUNAPI.userInfo, { token: this._token });
  }
  removeCodeParameter = (url) => {
    return url.replace(/(\?|&)code=[^&]*(&)?/g, function (p0, p1, p2) {
      return p1 === '?' || p2 ? p1 : '';
    });
  };
  removeStateParameter = (url) => {
    return url.replace(/(\?|&)state=[^&]*(&)?/g, function (p0, p1, p2) {
      return p1 === '?' || p2 ? p1 : '';
    });
  };
  // 登录成功
  loginSuccess(userinfo) {
    const _name = window.location.host.split('dotransit')[0].split('.')[1];
    axios.defaults.headers['token'] = userinfo.token;
    const _domain = (_name ? '.' + _name : '') + _CITY_.domain + this._config.domain;
    cookies.set('token', userinfo.token, { domain: _domain });
    cookies.set('userinfo', userinfo, { domain: _domain });
    cookies.set('tokenId', userinfo.token, { domain: _domain });
    // 区分开发测试和生产环境
    cookies.set('domain', _domain.slice(1), {
      domain: _domain,
    });
    // 三级域名
    if (_domain.split('.').length > 3) {
      localStorage.setItem('token', userinfo.token);
    }
  }
  // 退出登录，清除cookie
  clearLoginInfo() {
    const _name = window.location.host.split('dotransit')[0].split('.')[1];
    const _domain = _name + _CITY_.domain + this._config.domain;
    cookies.remove('token', { domain: _domain });
    cookies.remove('userinfo', { domain: _domain });
    cookies.remove('tokenId', { domain: _domain });
    // 兼容基层可视化系统
    if (!_domain.split('.').length > 3) {
      localStorage.removeItem('token');
    }
  }
  // 通过竹云code获取用户信息
  getUserInfoFromCode(authCode) {
    return axios
      .post(this.apiBaseURL + ZHUYUNAPI.getUserInfoFromCode, {
        authCode,
        systemCode: process.env.SYSTEMCODE,
      })
      .then((res) => {
        return Promise.resolve(res.data.data);
      })
      .catch((err) => {
        err && err.cancelAlert && err.cancelAlert();
        if (this.timer) return;
        this.timer = setTimeout(() => {
          Modal.info({
            // title: '登录过期了！',
            content: (err && err.data && err.data.msg) || '统一用户登录失败，请联系管理员！',
            okText: '关闭',
            onOk: () => {
              window.location.href = this.szbusZhuyunInfo && this.szbusZhuyunInfo.bamIndexUrl;
            },
          });
        }, 0);
        return Promise.resolve(null);
      });
  }
  // 判断页面来源
  async getPageFrom() {
    const current_url = window.location.href;
    let userInfo = null;
    // 判断是否是竹云登录后跳转过来
    try {
      if (current_url.includes('code=') && current_url.includes('state=')) {
        const code = this.getAuthCode(current_url);
        userInfo = await this.getUserInfoFromCode(code);
        // console.log('----有code----', code, userInfo, process.env.SYSTEMCODE)
        if (userInfo) {
          this.loginSuccess(userInfo);
          axios.defaults.headers.token = userInfo.token;
          let newUrl = this.removeCodeParameter(current_url);
          newUrl = this.removeStateParameter(newUrl);
          newUrl = newUrl.replace(/(\?|&)?sourceweb=bam/g, '');
          window.location.href = newUrl;
          return Promise.resolve(userInfo.token);
        } else {
          return Promise.reject('用户授权失败');
        }
      }
      if (!!this._token) {
        // console.log('----无code----')
        // 正常访问
        axios.defaults.headers.token = this._token;
        this.getUserInfo().then((res) => {
          if (res.data.code !== 0) {
            this.gotoLoginPage();
          }
          userInfo = res.data.data;
          auth.setUser(userInfo);
          // console.log('----有token----', userInfo)
          return Promise.resolve(userInfo);
        });
        return;
      }
      // console.log('----无token----')
      this.gotoLoginPage();
    } catch (err) {
      console.log('----出错了-----', err);
    }
  }
  // 判断在竹云是否有配置
  async judgeZhuyunConfig() {
    const configInfo =
      localStorage.getItem('zhuyunSys') && JSON.parse(localStorage.getItem('zhuyunSys'));
    if (!this.isFirst && configInfo) {
      this.isFirst = false;
      this.szbusZhuyunInfo = configInfo;
      this.szbusApiUrl = configInfo.authUrl;
      return Promise.resolve(true);
    }
    // return Promise.resolve(true)
    return axios
      .post(this.apiBaseURL + ZHUYUNAPI.getZhuyunConfig, {
        systemCode: process.env.SYSTEMCODE,
      })
      .then((res) => {
        const sysInfo = res.data.data || [];
        if (sysInfo.length) {
          this.szbusApiUrl = sysInfo[0].authUrl;
          this.szbusZhuyunInfo = sysInfo[0];
          localStorage.setItem('zhuyunSys', JSON.stringify(sysInfo[0]));
          return Promise.resolve(true);
        } else {
          this.szbusApiUrl = null;
          this.szbusZhuyunInfo = {};
          localStorage.removeItem('zhuyunSys');
          return Promise.reject(false);
        }
      })
      .catch((err) => {
        this.szbusApiUrl = null;
        this.szbusZhuyunInfo = {};
        localStorage.removeItem('zhuyunSys');
        return Promise.resolve(false);
      });
  }
  async gotoLoginPage() {
    const current_url = window.location.href;
    // 从子系统跳转到登录系统的，不做跳竹云处理
    if (process.env.SYSTEMCODE === 'passport' && current_url.indexOf('goto=') > -1) {
      return;
    }
    // 如果是从深巴跳转过来的，特殊处理
    let fromBamIndex = false;
    if (current_url.indexOf('sourceweb=bam') > -1) {
      fromBamIndex = true;
    }
    // 不是从竹云登录跳过来，先判断系统是否有竹云配置
    // 有竹云配置，跳转到竹云登录首页,否则跳passport页面
    if (
      this.szbusApiUrl &&
      _CITY_.city === 'shenzhen' &&
      ((this._userinfo && this._userinfo.loginType === 2) || fromBamIndex)
    ) {
      const _curUrl = current_url.replace(/(\?|&)?sourceweb=bam/g, '');
      const REDIRECT_URL = `${this.szbusApiUrl}/idp/oauth2/authorize?state=xxxx&client_id=${this.szbusZhuyunInfo.clientId}&response_type=code&redirect_uri=${_curUrl}`;
      window.location.href = REDIRECT_URL;
      return;
    }
    this.toPassportPage();
  }
  // 跳转到passport页面
  toPassportPage() {
    const current_url = window.location.href;
    localStorage.removeItem('zhuyunSys');
    if (process.env.SYSTEMCODE === 'passport' && current_url.indexOf('portal') === -1) {
      return;
    }
    this.clearLoginInfo();
    window.location.href = window.location.origin;
  }
  // 退出登录
  async logout() {
    const isConfigZhuyun = await this.judgeZhuyunConfig();
    if (isConfigZhuyun && _CITY_.city === 'shenzhen') {
      localStorage.removeItem('zhuyunSys');
      // 防止出现无token的情况
      if (cookies.get('token')) {
        this.serviceLogout();
      }
      this.clearLoginInfo();
      // 竹云配置，跳转到竹云系统主页
      if (this.szbusZhuyunInfo.bamIndexUrl) {
        window.location.href = this.szbusZhuyunInfo.bamIndexUrl;
        return;
      }
      if (process.env.SYSTEMCODE === 'passport') {
        window.location.reload();
        return;
      }
      return;
    }
    this.passportloginout();
  }
  serviceLogout() {
    return axios.post(this.apiBaseURL + ZHUYUNAPI.loginout, {});
  }
  async passportloginout() {
    await this.serviceLogout();
    this.toPassportPage();
  }
  async pageInit() {
    const curHref = window.location.href;
    if (curHref.indexOf('goto=') > -1) {
      this.fromSysUrl = curHref.split('?goto=')[1];
      const systemCode = curHref.split('?goto=')[1].split('//')[1].split('.')[0];
      try {
        const info = await this.commonGetInterfaceData(ZHUYUNAPI.getZhuyunConfig, { systemCode });
        if (info && info.length > 0) {
          this.szbusApiUrl = info[0].authUrl;
          this.fromSysClientId = info[0].clientId;
        }
      } catch (err) {
        console.log(err);
      }
    }
  }
  gotoSzBus() {
    const redirect_uri = this.fromSysUrl ? this.fromSysUrl : window.location.href,
      client_id = this.fromSysUrl ? this.fromSysClientId : this.szbusZhuyunInfo.clientId;
    let goto_url = `${this.szbusApiUrl}/idp/oauth2/authorize?state=xxxx&client_id=${client_id}&response_type=code&redirect_uri=${redirect_uri}`;
    // 如果登录系统和跳转过来的系统均关闭竹云，则直接跳深巴集团登录页面，不带任何参数
    if (!this.szbusApiUrl || !client_id) {
      goto_url = ZHUYUNLOGINURL[process.env.BUILD_TO];
    }
    window.location.href = goto_url;
    // console.log(goto_url)
  }
}

export default new ZhuyunLogin();



// WEBPACK FOOTER //
// ./src/service/zhuyunLogin.js